export const type = 'alert.sender';
